import React from 'react';
import { airportProductCatalog } from '../../seo/airportProducts';

const AirportProductsSchema = ({ airportKey }) => {
  const items = airportProductCatalog[airportKey] || [];
  if (!items.length) return null;

  const graph = items.map(p => ({
    "@type": "Product",
    "name": p.name,
    "image": p.image,
    "description": p.description,
    "brand": { "@type": "Brand", "name": p.brand },
    "sku": p.sku,
    "url": p.url,
    "category": p.category,
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": p.ratingValue,
      "reviewCount": p.reviewCount
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": p.priceCurrency,
      "price": p.price,
      "availability": p.availability,
      "url": p.url
    }
  }));

  const jsonLd = {
    "@context": "https://schema.org/",
    "@graph": graph
  };

  return (
    <script 
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} 
    />
  );
};

export default AirportProductsSchema;

